// import PropTypes from 'prop-types'
import SelectInput from 'components/SelectInput'

import { Root } from './ProductColorOptions.style'

// import Debug from 'components/Debug'
// import image from 'next/image'

const skusToOptions = ({ skus }) => {
  return skus.map(({ name, image }) => ({ value: name, label: name, image }))
}

const ProductColorOptions = ({ colors, value, onChange = () => {} }) => {
  if (!colors) return null

  const handleChange = ({ value }) => onChange('color', value)
  const colorOptions = skusToOptions({ skus: colors })
  const colorValue = value || colorOptions[0]
  const colorValueOption = colorOptions.find((option) => option.value === colorValue)

  return (
    <Root>
      <SelectInput
        options={colorOptions}
        defaultValue={colorValue}
        value={colorValueOption}
        onChange={handleChange}
        isSearchable={false}
      />
    </Root>
  )
}

ProductColorOptions.propTypes = {}

ProductColorOptions.defaultProps = {}

export default ProductColorOptions
